// main.ts
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import * as Sentry from "@sentry/angular";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import { hmrBootstrap } from "./hmr";
import { APP_CONFIG } from "#root/config/constants/app-config.constant";

if (environment.production) {
  enableProdMode();
}

export const isActiveAllDashboard = true;

if (environment.sentryDSN) {
  Sentry.init({
    dsn: environment.sentryDSN,
    integrations: [
      Sentry.globalHandlersIntegration({
        onerror: true,
        onunhandledrejection: true,
      }),
      Sentry.browserTracingIntegration({}),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [
          /https:\/\/apiip-h6gfe6dvfbdngzbd\.eastus2-01\.azurewebsites\.net\/api\/v1\/([a-z]+(?:\/[a-z]+)*)/i,
        ],
        networkRequestHeaders: ["X-Custom-Header"],
        networkResponseHeaders: ["X-Custom-Header"],
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      "Unknown Error.",
      "Unknown Error",
      'Error: Could not load "util".',
    ],
  });
  Sentry.setContext("app", {
    name: APP_CONFIG.appName || "CRM Inmobiliaria Platino",
    version: environment.version || "0.0.0",
  });
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
  if (module["hot"]) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error("HMR is not enabled for webpack-dev-server!");
    console.log("Are you using the --hmr flag for ng serve?");
  }
} else {
  bootstrap().catch((err) => console.log(err));
}
